<template>
  <div>
    <el-table :data="list" style="width: 100%" :header-cell-style="{
      background: '#F3F3F3',
      color: '#1F3349',
      fontSize: '15px',
      fontWeight: 'normal',
    }" :cell-style="{ fontSize: '15px', color: '#666666' }">
      <el-table-column prop="order_no" label="订单号" width="250" />
      <el-table-column prop="amount" label="订单金额" />
      <el-table-column prop="num" label="数量合计" />
      <el-table-column prop="payment_type" label="支付方式">
        <template slot-scope="scope">
          {{ getPayTypeName(scope.row.payment_type) }}
        </template>
      </el-table-column>
      <el-table-column prop="operator.nickname" label="支付状态">
        <template slot-scope="scope">
          {{ getStatusName(scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column prop="operator.nickname" label="收银员" />
      <el-table-column prop="created_at" label="时间" width="200" />
      <!-- 操作 -->
      <el-table-column fixed="right" align="center" label="操作" width="200">
        <template slot-scope="scope">
          <div class="flex flex_items flex_center">
            <div @click="handleClick(scope.row)" class="main_color pointer page-handle-btn">
              详情
            </div>
            <!-- <div @click="outPay(scope.row)" v-if="role.includes('v1.window.order.refund')"
              class="main_color pointer page-handle-btn">
              退票
            </div> -->
          </div>
        </template>
      </el-table-column>
      <div slot="empty" style="text-align: center;width:100%">
        暂无数据
      </div>
    </el-table>

    <div class="flex flex_end pagination" v-if="total > 10">
      <el-pagination background layout="prev, pager, next,sizes,jumper" :total="total" @current-change="currentChange"
        :current-page="currentPage" :page-size="pageSize" @size-change="pageSizeC">
      </el-pagination>
    </div>

    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :show-close="true" title="详情"
      :visible.sync="dialogVisible" width="80%">
      <div class="flex flex_end">
        <el-button type="text" @click="outPay()" v-if="role.includes('v1.window.order.refund.yearCard')">退票</el-button>
      </div>
      <table>
        <tr>
          <td class="tab-bg">订单号</td>
          <td>{{ order.order_no }}</td>
          <td class="tab-bg">卡数</td>
          <td>{{ order.num }}</td>
          <td class="tab-bg">总金额</td>
          <td>{{ order.amount }}</td>
        </tr>
        <tr>
          <td class="tab-bg">下单时间</td>
          <td>{{ order.created_at }}</td>
          <td class="tab-bg">总金额</td>
          <td>{{ order.amount }}</td>
          <td class="tab-bg">支付方式</td>
          <td>{{ getPayTypeName(order.payment_type) }}</td>
        </tr>
        <tr>
          <td class="tab-bg">购票人电话</td>
          <td>{{ order.contact_mobile }}</td>
          <td class="tab-bg">购票人姓名</td>
          <td>{{ order.contacts }}</td>
          <td class="tab-bg">备注</td>
          <td>{{ order.notes }}</td>
        </tr>
        <tr>
          <td class="tab-bg">已退数</td>
          <td>{{ order.start_time }}</td>
          <td class="tab-bg">退款金额</td>
          <td>{{ order.end_time }}</td>
          <td class="tab-bg">退款人</td>
          <td>{{ order.operator ? order.operator.nickname : '' }}</td>
        </tr>
      </table>

      <el-table :data="orderDetail" class="mt20" style="width: 100%" :header-cell-style="{
        background: '#F3F3F3', color: '#1F3349', fontSize: '15px', fontWeight: 'normal',
      }" :cell-style="{ fontSize: '15px', color: '#666666' }">
        <el-table-column prop="card.name" label="产品名称" width="200" />
        <el-table-column prop="price" label="单价" />
        <el-table-column prop="tourist_name" label="会员名称" />
        <el-table-column prop="tourist_phone" label="会员电话" />
        <el-table-column prop="tourist_code" label="会员证件号" />
        <el-table-column prop="operator.nickname" label="支付状态">
          <template slot-scope="scope">
            {{ order.status == 9 ? '支付失败' : order.status == 1 ? '支付成功' : '' }}
          </template>
        </el-table-column>
        <div slot="empty" style="text-align: center;width:100%">
          暂无数据
        </div>
      </el-table>

    </el-dialog>
  </div>
</template>
<script>
import { getStatusName } from '@/utils/index'
export default {
  props: {
    endTime: {
      default: ''
    },
    startTime: {
      default: ''
    },
    order_no: {
      default: ''
    },
    tourist_name: {
      default: ''
    },
    tourist_phone: {
      default: ''
    },
    tourist_code: {
      default: ''
    },
  },
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pay_type: [],
      role: [],
      order: {},
      dialogVisible: false,
      orderDetail: [],
      pageSize: 10,
      getStatusName: getStatusName
    }
  },
  created() {
    this.role = this.$store.getters.roles ? this.$store.getters.roles : [];
    // this.handleClick({ id: 39 })
  },
  methods: {
    outPay(e) {
      this.$router.push('/refundTicket?search=' + this.order.order_no + '&type=2')
    },
    resetData() {
      this.currentPage = 1;
      this.getList()
    },
    currentChange(e) {
      this.currentPage = e
      this.getList();
    },
    pageSizeC(e) {
      this.pageSize = e;
      this.getList()
    },
    getList() {
      this.api.getUrl('/api/v1/window/order/yearCard', {
        size: this.pageSize,
        page: this.currentPage,
        keyword: this.keyword,
        startTime: this.startTime,
        // startTime: '2025-04-09',
        endTime: this.endTime,
        order_no: this.order_no,
        tourist_name: this.tourist_name,
        tourist_phone: this.tourist_phone,
        tourist_code: this.tourist_code,
      }, { loading: true })
        .then((res) => {
          this.list = res.list;
          this.pay_type = res.pay_type;
          this.total = res.meta.total;
        });
    },
    getPayTypeName(s) {
      if (this.pay_type.length > 0 && s) {
        let k = this.pay_type.filter(r => r.key == s)[0];
        return k ? k.name : ''
      }
      return ''
    },
    handleClick(s) {
      this.api.getUrl('/api/v1/window/order/yearCard/detail/' + s.id, {}, { loading: true }).then(res => {
        this.dialogVisible = true;
        this.order = res.order;
        this.orderDetail = res.order.detail;
      })

    },
    // makeup(s) {
    //   this.api.getUrl('/api/v1/window/order/makeup/' + s.id, {}, { loading: true }).then(res => {
    //     this.$message.success('操作成功')
    //   })
    // },


  }
}
</script>
<style scoped>
table {
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  width: 100%;
  border-collapse: collapse;
}

td {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  height: 45px;
  padding: 5px;
}

.tab-bg {
  background: #fafafa;
  width: 10%;
}

td {
  width: 20%;
}
</style>
